import React, { createContext, useContext, useState, useRef } from 'react';
import useOverlayLayers from '../hooks/useOverlayLayersSelector';
import { useConfig } from '../hooks/useConfig';
import { useUserSession } from '../hooks/useUserSession';

const GlobalVariablesContext = createContext();

const GlobalVariablesProvider = ({ container, children }) => {

    if (!container) {
        throw new Error('GlobalVariablesProvider requires a container prop');
    }

    const [layerTypesToRefresh, setLayerTypesToRefresh] = useState(null);


    const mapRef = useRef(null);


    const configState = useConfig();
    const userSession = useUserSession();

    const [selectedFeatures, setSelectedFeatures] = useState([]);
    const [dataRowModified, setDataRowModified] = useState({});
    
    // Estados para el catastro
    const [layerCadastro, setLayerCadastro] = useState(null);
    const [cadastroData, setCadastroData] = useState(null);
    const [cadastroReferencia, setCadastroReferencia] = useState(null);
    
    // Estados para el PopUp
    const [popUpVisible, setPopUpVisible] = useState(false);
    const [popUpPosition, setPopUpPosition] = useState(null);
    const [popUpContent, setPopUpContent] = useState(null);

    // Hook para gestionar las capas overlay
    const overlayLayersState = useOverlayLayers(configState.config);

    /**
     * Helper function to get the ID of the current visor/viewer
     * @returns {number}    the ID of the visor/viewer
     */
    const getVisorID = () => {
        return parseInt(container.getAttribute('data-visor-id'));
    }

    /**
     * Helper function to get the ID of the current project
     * @returns {number}    the ID of the project
     */
    const getProjectID = () => {
        return parseInt(container.getAttribute('data-project-id'));
    }

    const [isLoading, setIsLoading] = useState(false);
    
    // Estados para el sidebar derecho
    const [sidebarOpenRight, setSidebarOpenRight] = useState(false);
    const [activeTabContentSidebarRight, setActiveTabContentSidebarRight] = useState('leyenda');
    
    // Estados para las consultas de atributos
    const [queriesResults, setQueriesResults] = useState({});


    return (
        <GlobalVariablesContext.Provider
            value={{
                ...userSession,
                ...configState, // Incluye { config, loading, error } desde useConfig
                ...overlayLayersState, // Incluye visibleOverlayLayers, opacities, etc.
                selectedFeatures, setSelectedFeatures, // Array de features seleccionados
                isLoading, setIsLoading,  // control estado del spinner de carga
                mapRef,
                getVisorID,
                getProjectID,
                dataRowModified, setDataRowModified,      // para actualizar datos dinámicamente en datatables
                layerTypesToRefresh, setLayerTypesToRefresh,  // actulizar capas según tipo indicado (puede haber varias)
                // Variables del catastro
                layerCadastro, setLayerCadastro,
                cadastroData, setCadastroData,
                cadastroReferencia, setCadastroReferencia,
                // Variables del PopUp
                popUpVisible, setPopUpVisible,
                popUpPosition, setPopUpPosition,
                popUpContent, setPopUpContent,
                // Variables del sidebar derecho
                sidebarOpenRight, setSidebarOpenRight,
                activeTabContentSidebarRight, setActiveTabContentSidebarRight,
                // Variables de consultas
                queriesResults, setQueriesResults
            }}
        >
            {children}
        </GlobalVariablesContext.Provider>
    )
}

export const useGlobalVariablesContext = () => {
    return useContext(GlobalVariablesContext)
}

export { GlobalVariablesProvider, GlobalVariablesContext }
